import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import PostForm from '../PostForm';
import * as S from './CreatePostModal.styles';

interface CreatePostModalProps {
  open: boolean;
  onClose: () => void;
  project_id?: number;
}

const CreatePostModal: React.FC<CreatePostModalProps> = ({ open, onClose, project_id }) => {
  return (
    <S.StyledDialog open={open} onClose={onClose} maxWidth="md">
      <S.ModalHeader>
        <h2>Create Post</h2>
        <S.CloseButton onClick={onClose}>
          <CloseIcon />
        </S.CloseButton>
      </S.ModalHeader>
      <PostForm onPostCreated={onClose} project_id={project_id} onClose={onClose} />
    </S.StyledDialog>
  );
};

export default CreatePostModal;
